import React, { useState } from 'react';
import axios from 'axios';
import "./ResetPassword.css";
import { Container } from 'react-bootstrap';
import { useParams, useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useTranslation } from "../../contexts/TranslationContext";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const ResetPassword = ({ url }) => {
    // const { email, code, isComingFromBookingDemo } = useParams();
    // const decodedEmail = decodeURIComponent(email);
    // const decodedCode = decodeURIComponent(code);
    const { t } = useTranslation();
    const { code, userIdentifier } = useParams();
    const decodedCode = decodeURIComponent(code);
    const decodedIdentifier = decodeURIComponent(userIdentifier);


    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false); // New state for button disabling
    const [loading, setLoading] = useState(false); // New state for loading

    // const handleSubmit = async () => {
    //     if (!decodedEmail || !decodedCode) {
    //         setError('Invalid reset link.');
    //         return;
    //     }

    //     if (password !== confirmPassword) {
    //         setError('Passwords do not match.');
    //         return;
    //     }

    //     setIsSubmitting(true); // Disable the button when the request is sent
    //     setLoading(true); // Show loading state

    //     try {
    //         const response = await axios.post(`${url}/`, {
    //             key: decodedCode,
    //             new_password: password,
    //             confirm_password: confirmPassword,
    //             cmd: 'frappe.core.doctype.user.user.update_password',
    //             email: decodedEmail,
    //             logout_all_sessions: 1,
    //         });


    //         const { authentication, full_name, user_image, sid, preferred_language, message } = response.data;


    //         // Store api_key, api_secret, username, full_name, and user_image in cookies
    //         Cookies.set('api_key', authentication.api_key);
    //         Cookies.set('api_secret', authentication.api_secret);
    //         Cookies.set('full_name', full_name);
    //         Cookies.set('sid', sid);
    //         Cookies.set('preferred_language', preferred_language)
    //         Cookies.set('username', message.email)

    //         window.location.href = "/login";

    //     } catch (error) {
    //         // Check if there's a response from the server
    //         if (error.response && error.response.data) {
    //             const serverMessage = error.response.data.exception || error.response.data._server_messages;

    //             // Clean up the server message to remove 'frappe.exceptions.ValidationError:'
    //             const cleanedMessage = serverMessage
    //                 ? serverMessage.replace(/frappe\.exceptions\.ValidationError:\s*/g, '')
    //                 : '';

    //             setError(cleanedMessage || 'Password reset failed. Please try again.');
    //         } else {
    //             setError('Password reset failed. Please try again.');
    //         }
    //     } finally {
    //         setIsSubmitting(false); // Re-enable the button after the request is complete
    //         setLoading(false); // Hide loading state
    //     }
    // };
   
    const handleSubmit = async () => {
        if (!userIdentifier || !decodedCode) {
            setError(t("InvalidResetLink"));
            return;
        }

        if (password !== confirmPassword) {
            setError(t("PasswordsDoNotMatch"));
            return;
        }

        setIsSubmitting(true);
        setLoading(true);

        try {
            const requestBody = {
                code: decodedCode,
                password: password
            };

            if (/^\+?\d+$/.test(decodedIdentifier)) {
                requestBody.phone = decodedIdentifier;
            } else {
                requestBody.email = decodedIdentifier;
            }


            const response = await axios.post(
                "https://crm.alltimestravels.com/api/method/alltimes.www.auth.update_password",
                requestBody,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.data.message === "Password updated successfully" || response.status === 200) {
                 toast.success(t("ThePasswordSuccessfullyUpdated"));
                window.location.href = "/login";
            } else {
                setError(t("PasswordUpdateFailed"));
            }
        } catch (error) {
            console.error(error);
            setError(t("AnErrorOccurredWhileUpdatingPassword"));
        } finally {
            setIsSubmitting(false);
            setLoading(false);
        }
    };
    return (
        <div className='auth'>
            <div className='check-email-container'>
                <Container>
                    <div className='reset-password-image'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="19" viewBox="0 0 26 19" fill="none">
                            <path d="M25.5575 2.56209L9.56227 18.5589C9.42295 18.6987 9.25741 18.8096 9.07514 18.8853C8.89287 18.961 8.69744 19 8.50008 19C8.30272 19 8.1073 18.961 7.92502 18.8853C7.74275 18.8096 7.57721 18.6987 7.4379 18.5589L0.439971 11.5603C0.300483 11.4208 0.189835 11.2552 0.114345 11.0729C0.0388544 10.8906 2.07854e-09 10.6953 0 10.498C-2.07853e-09 10.3007 0.0388544 10.1054 0.114345 9.9231C0.189835 9.74084 0.300483 9.57522 0.439971 9.43572C0.57946 9.29622 0.745056 9.18556 0.927306 9.11006C1.10956 9.03457 1.30489 8.99571 1.50216 8.99571C1.69942 8.99571 1.89476 9.03457 2.07701 9.11006C2.25926 9.18556 2.42485 9.29622 2.56434 9.43572L8.50133 15.3733L23.4357 0.440014C23.7174 0.158278 24.0994 0 24.4978 0C24.8962 0 25.2783 0.158278 25.56 0.440014C25.8417 0.72175 26 1.10387 26 1.5023C26 1.90074 25.8417 2.28285 25.56 2.56459L25.5575 2.56209Z" fill="#61AF64" />
                        </svg>
                    </div>
                    <h1 className='check-email-title'>
                        {t("AccountVerified")}
                    </h1>
                    <p className='check-email-para'>
                        {t("PleaseResetYourPassword")}
                    </p>
                    <input
                        type='password'
                        className='login-field password-field'
                        placeholder={t("NewPassword")}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <input
                        type='password'
                        className='login-field password-field'
                        placeholder={t("ConfirmPassword")}
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                    {error && <p className='error-message'>{error}</p>}
                    <button
                        className='login-submit'
                        onClick={handleSubmit}
                        disabled={isSubmitting} // Disable the button based on isSubmitting state
                    >
                         {loading ? t("Loading") : t("Continue")}
                    </button>
                </Container>
            </div>
            <ToastContainer
                position="bottom-right"
                hideProgressBar="true"
                type="error"
            />
        </div>
    );
};

export default ResetPassword;
